import { el, mount, setAttr } from 'redom';

class HTVideo extends HTMLElement {

  constructor() {

    super();

    this.attachShadow({ mode: 'open' });

    this.src = null;
    this.video = el('video.ht-files-display-video', { controls: true, muted: true });

    mount(this.shadowRoot, this.getStyleEl());

    mount(this.shadowRoot, this.video);

  }

  initialize() {
    setAttr(this.video, {
      src: this.src
    });
  }

  getStyleEl() {
    const styleCode = `
      .ht-files-display-video {
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }
      .ht-files-display-video.squaredcorners {
        border-radius: unset;
      }
    `;

    const style = el('style', styleCode);

    return style;
  }

  connectedCallback() {

    this.src = this.getAttribute('src');

    if (this.hasAttribute('source') === true) {
      this.src = this.getAttribute('source');
    }

    if (this.hasAttribute('squaredcorners') === true) {
      this.video.classList.add('squaredcorners');
    }

    this.initialize();

  }

  isSourceAttribute(name) {

    return ['src', 'source'].indexOf(name) === -1;

  }

  attributeChangedCallback(name, oldValue, newValue) {

    if (this.isSourceAttribute(name) === false) {
      return;
    }

    this.src = newValue;

    this.initialize();

  }

  disconnectedCallback() {

  }

  visible() {

    this.video.play().catch(function errorHandler() {

    });

  }

  invisible() {

    this.video.pause();

  }

  play() {

    this.video.play().catch(function errorHandler() {

    });

  }

}

export default HTVideo;